import { render } from "./FormularioBandeiraPagamento.vue?vue&type=template&id=5daa4136&scoped=true"
import script from "./FormularioBandeiraPagamento.vue?vue&type=script&lang=js"
export * from "./FormularioBandeiraPagamento.vue?vue&type=script&lang=js"

import "./FormularioBandeiraPagamento.vue?vue&type=style&index=0&id=5daa4136&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5daa4136"]])

export default __exports__